<script setup lang="ts">
import CenterModal from "~/components/Common/Modals/CenterModal.vue";
import LoadButton from "~/components/Common/Buttons/LoadButton.vue";
import AppButton from "../Buttons/AppButton.vue";

interface Props {
  title?: string;
  description?: string;
  consequences?: string[];
  backText?: string;
  cancelNotifyText?: string;
  confirmNotifyText?: string;
  loadingCancel?: boolean;
  loadingConfirm?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  title: "Voulez-vous envoyer une notification au participant ?",
  description: "Cette action ne sera pas modifiable.",
  consequences: () => ["Le prestataire sera notifié si vous avez renseigné un contact prestataire sur la session."],
  backText: "Retour",
  cancelNotifyText: "Ne pas envoyer",
  confirmNotifyText: "Envoyer",
  loadingCancel: false,
  loadingConfirm: false,
});

const emit = defineEmits<{
  hide: [];
  back: [];
  cancelNotify: [];
  confirmNotify: [];
}>();

const loadCancelNotification = ref(props.loadingCancel);
const loadConfirmNotification = ref(props.loadingConfirm);

const isAnyLoading = computed(() => loadCancelNotification.value || loadConfirmNotification.value);

watch(
  () => props.loadingCancel,
  (val) => {
    loadCancelNotification.value = val;
  },
);

watch(
  () => props.loadingConfirm,
  (val) => {
    loadConfirmNotification.value = val;
  },
);

function onHide() {
  emit("hide");
}

function onBack() {
  emit("back");
}

function onCancelNotify() {
  emit("cancelNotify");
}

function onConfirmNotify() {
  emit("confirmNotify");
}
</script>

<template>
  <CenterModal :style="{ 'max-width': '488px', width: '100%' }" @hide="onHide">
    <template #body>
      <div class="grid p-[24px] gap-[24px] body_regular">
        <div class="flex flex-col gap-2">
          <h4 class="heading_4_demi">
            {{ title }}
          </h4>
          <p class="text-secondary-color">
            {{ description }}
          </p>
        </div>
        <ul v-if="consequences.length" class="list-disc list-outside grid gap-2 body_regular pl-6">
          <li v-for="(consequence, index) in consequences" :key="index">
            {{ consequence }}
          </li>
        </ul>
        <div class="flex justify-center gap-[16px]">
          <AppButton type="outlined" class="w-full" :label="backText" @click="onBack" />
          <LoadButton
            v-model="loadCancelNotification"
            :disabled="isAnyLoading"
            class="w-full"
            reverse
            :text-confirm="cancelNotifyText"
            force-waiting
            @click="onCancelNotify"
          />
          <LoadButton
            v-model="loadConfirmNotification"
            :disabled="isAnyLoading"
            class="w-full"
            :text-confirm="confirmNotifyText"
            force-waiting
            @click="onConfirmNotify"
          />
        </div>
      </div>
    </template>
  </CenterModal>
</template>

<style scoped lang="scss"></style>
